import {
  Container,
  Grid,
  Button,
  Switch,
  FormControlLabel,
} from '@mui/material';
import React from 'react';
import { Box } from '@mui/system';
import { useTranslate } from 'react-admin';

function CategoryBar({ onSave, isActive, setIsActive }: any) {
  const t = useTranslate();
  return (
    <Container
      sx={{
        justifyContent: 'space-between',
        display: 'flex',
      }}
    >
      <Box>
        <FormControlLabel
          control={
            <Switch
              defaultChecked
              checked={isActive}
              color='success'
              onChange={() => setIsActive(!isActive)}
            />
          }
          label={t('active')}
        />
      </Box>
      <Box>
        <Button onClick={onSave}>{t('save')}</Button>
      </Box>
    </Container>
  );
}

export default CategoryBar;
